var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.44444C3 5.98985 4.98985 4 7.44444 4H18.5556C21.0102 4 23 5.98985 23 8.44444C23 8.98773 22.6884 9.48288 22.1986 9.71798L21.7113 9.95192C19.993 10.7767 19.993 13.2233 21.7113 14.0481L22.1986 14.282C22.6884 14.5171 23 15.0123 23 15.5556C23 18.0102 21.0102 20 18.5556 20H7.44444C4.98985 20 3 18.0102 3 15.5556C3 15.0123 3.31157 14.5171 3.80135 14.282L4.28872 14.0481C6.00702 13.2233 6.00702 10.7767 4.28872 9.95192L3.80135 9.71798C3.31157 9.48288 3 8.98773 3 8.44444Z",
    stroke: "#341439",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0175 9.73737C12.3268 8.75421 13.6732 8.75421 13.9825 9.73737C14.1208 10.177 14.5174 10.4747 14.965 10.4747C15.9657 10.4747 16.3818 11.7976 15.5722 12.4052C15.2101 12.6769 15.0586 13.1586 15.1969 13.5983C15.5062 14.5814 14.4168 15.399 13.6072 14.7914C13.2451 14.5196 12.7549 14.5196 12.3928 14.7914C11.5832 15.399 10.4938 14.5814 10.8031 13.5983C10.9414 13.1586 10.7899 12.6769 10.4278 12.4052C9.6182 11.7976 10.0343 10.4747 11.035 10.4747C11.4826 10.4747 11.8792 10.177 12.0175 9.73737Z",
    stroke: "#341439",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02);
export default __webpack_public_path__ + "static/media/02.e28436107dc44df13210d7988b0d0242.svg";
export { ForwardRef as ReactComponent };